import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import User from "../../auth/User";
import {
  makeStyles,
  createStyles,
  Fab,
  Typography,
  Button,
} from "@material-ui/core";

import LogoutIcon from "@material-ui/icons/MeetingRoom";
import { delayReplace } from "../../helper/Util";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "calc(100vh - 58px)", // topbarの高さ分を引く(progressBar込み)
      [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
        minHeight: "calc(100vh - 50px)",
      },
      [theme.breakpoints.up("sm")]: {
        minHeight: "calc(100vh - 66px)",
      },
    },
    icon: {
      marginBottom: theme.spacing(4),
    },
    title: {
      width: "78%",
      maxWidth: "350px",
      marginBottom: theme.spacing(1),
    },
    text: {
      width: "78%",
      maxWidth: "350px",
      fontSize: 18,
      marginBottom: theme.spacing(6),
    },
    forgotButton: {
      fontSize: 20,
    },
  })
);

export default function Logout() {
  const classes = useStyles();

  useEffect(() => {
    // useEffect()内で非同期関数を直接呼び出せないため、
    // 回避策として冗長的に記述している
    const doLogout = async () => {
      await User.logout();
    };
    doLogout();
  }, []);

  const history = useHistory();

  const handleClickToLoginButton = () => {
    delayReplace(history, "/login");
  };

  return (
    <div className={classes.root}>
      <Fab
        className={classes.icon}
        color="primary"
        disableRipple
        disableFocusRipple
      >
        <LogoutIcon />
      </Fab>

      <Typography variant="h6" className={classes.title}>
        ログアウトしました
      </Typography>

      <Typography className={classes.text} color="textSecondary">
        ご利用ありがとうございました
      </Typography>

      <Button
        className={classes.forgotButton}
        color="primary"
        onClick={handleClickToLoginButton}
      >
        ログイン画面へ
      </Button>
    </div>
  );
}
